$ ->
  if $('.lessonActivitiesIndexView').length
    new LessonActivitiesIndex()

class LessonActivitiesIndex
  constructor: ->
    @bindElements()

  bindElements: ->
    $("#user-activities-results").on "click", ".shareActivity", (e) =>
      @performAction(e)
    $("#user-activities-results").on "click", ".removeActivity", (e) =>
      @performAction(e)

  performAction: (e) ->
    targetUrl      = $(e.currentTarget).attr('data-url')
    method         = $(e.currentTarget).attr('data-method')
    confirmMessage = $(e.currentTarget).attr('data-confirm')

    return if targetUrl == '#'

    if (typeof(confirmMessage) == 'undefined' || confirm(confirmMessage))
      $.ajax
        type: method
        url: targetUrl
        dataType: 'script'
